<template>
  <v-progress-circular
    :size="size"
    :width="width"
    class="circular-progress"
    indeterminate
  />
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 32
    },
    width: {
      type: Number,
      default: 4
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/styles/_responsive.less";
@import "../assets/styles/_variables.less";

.circular-progress {
  /deep/ .v-progress-circular__overlay {
    stroke: @mid-orange;
  }
}
</style>
